'use client';

import { useEffect, useSyncExternalStore, type ReactNode } from 'react';
import {
    getConsentSnapshot,
    getServerConsentSnapshot,
    initializeConsentStore,
    openPreferenceCenter,
    subscribeConsent,
    updateConsentPresentation,
} from '@/contexts/consent/store';

interface ConsentProviderProps {
    /** 应用子树，不等待 Consent 或 SDK 初始化。 */
    children: ReactNode;
    /** 由宿主语言能力解析的当前语言。 */
    locale: string;
    /** Cookie UI 使用实际展示主题，而非用户被保留的主题偏好。 */
    theme?: 'light' | 'dark';
}

export function CookieConsentProvider({ children, locale, theme = 'light' }: ConsentProviderProps) {
    useEffect(() => {
        const unsubscribe = subscribeConsent(() => {});
        return unsubscribe;
    }, []);
    useEffect(() => {
        void initializeConsentStore({ locale, theme });
    }, [locale, theme]);

    return children;
}

export function ConsentPresentationSync({ locale, theme }: Pick<ConsentProviderProps, 'locale' | 'theme'>) {
    useEffect(() => updateConsentPresentation({ locale, theme }), [locale, theme]);
    return null;
}

export function useCookieConsent() {
    const snapshot = useSyncExternalStore(subscribeConsent, getConsentSnapshot, getServerConsentSnapshot);
    return { ...snapshot, openPreferenceCenter };
}
